import React from "react"
import PropTypes from "prop-types"
import "./index.less"
import { validate } from "../../../../../utils/functions"

export function CustomTooltip(props) {
  let payload = null
  if (validate.exist(props.element) && props.element.active) {
    if (
      validate.exist(props.element.payload) &&
      props.element.payload.length > 0
    ) {
      payload = props.element.payload[0].payload
    }
  }
  if (payload === null) {
    return null
  }

  return (
    <div className="tooltipBarChartDivisionNotHistory">
      {payload.employees}{" "}
      {payload.employees > 1 ? "colaboradores" : "colaborador"}
    </div>
  )
}

CustomTooltip.propTypes = {
  element: PropTypes.object,
  measureGeneral: PropTypes.object,
}

export default CustomTooltip
